
// import Cookies from 'js-cookie';

export const setToken = tokenid => {
  // token = tokenid;
  if (process.env.VUE_ENV === 'server') {
    return;
  }
  // Cookies.set('token', tokenid, {
  //   expires: 15
  // });
  window.localStorage.setItem('token', tokenid)
};

export const getToken = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
    // return token;
  }

  // return Cookies.get('token');
  return window.localStorage.getItem('token') || '';
};

const clearToken = () => {
  // Cookies.remove('token');
  // Cookies.remove('token', { domain: '.huishoubao.com' });
  // Cookies.remove('token', { domain: 'huishoubao.com' });
  window.localStorage.removeItem('token')
};

export const getUserInfo = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }

  try {
    const unfo = JSON.parse(window.localStorage.getItem('uinfo'));
    return unfo;
  } catch (err) {
    // console.log(err);
  }
};

export const setUserInfo = (tel, name, openid, headimgurl) => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }

  let info = {
    name,
    openid,
    headimgurl
  };

  if (typeof tel === 'object') {
    Object.assign(info, tel);
  } else {
    info.tel = tel;
  }

  window.localStorage.setItem('uinfo', JSON.stringify(info));
};

export const updateUserTel = tel => {
  const uInfo = getUserInfo();
  uInfo.tel = tel;
  setUserInfo(uInfo);
};

export const clearUserInfo = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }
  clearToken();
  window.localStorage.removeItem('uinfo');
};
